import React from 'react';

const TransactionArchitecture = () => {
  return (
    <section className="relative">
      {/* Header */}
      <div className="bg-cream-100 py-10 md:py-14 text-center px-6">
        <h2
          className="font-serif text-2xl md:text-3xl lg:text-4xl font-bold text-navy-900 tracking-wide mb-1"
          data-aos="fade-down"
        >
          Core Transaction
        </h2>
        <h2 className="font-serif text-2xl md:text-3xl lg:text-4xl font-bold text-navy-900 tracking-wide mb-2">
          Architecture Advisory
        </h2>
        <p className="font-body text-lg md:text-xl text-navy-900/60 italic">
          &amp; Licensed Network
        </p>
        <div className="gold-divider max-w-lg mx-auto mt-6" />
      </div>

      {/* First skyline window — transparent */}
      <div className="h-[200px] md:h-[300px] lg:h-[350px]" />

      {/* Content */}
      <div className="bg-cream-100 py-10 md:py-14 px-6 md:px-12">
        <div className="max-w-3xl mx-auto text-center" data-aos="fade-up">
          <p className="font-body text-base md:text-lg lg:text-xl text-navy-900/80 leading-relaxed mb-6">
            <span className="font-bold text-navy-900">Marquee</span> may
            coordinate or facilitate introductions to licensed third
            parties, including investment banks, regulated brokers,
            underwriters, legal counsel, and accounting firms where such
            parties are required for execution.
          </p>
          <p className="font-body text-sm md:text-base text-navy-900/60 leading-relaxed italic">
            Marquee Commodity Group provides advisory and management
            consultancy services only. We are not broker-dealers,
            underwriters, placement agents, or capital sponsors. Regulated
            execution is performed by duly licensed third parties.
          </p>
        </div>
      </div>

      {/* Second skyline window — transparent */}
      <div className="h-[200px] md:h-[300px] lg:h-[350px]" />

      {/* Bottom bar */}
      <div className="dark-section py-5 md:py-6 text-center border-t border-gold-500/20">
        <p className="font-serif text-base md:text-lg text-gold-400 tracking-widest">
          Independent Transaction Architecture Platform
        </p>
      </div>
    </section>
  );
};

export default TransactionArchitecture;
